import Component from '@ember/component';
import { action, computed, get, set } from '@ember/object';
import { empty } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';
import filterUtils from 'donor-elf-web/lib/filter-utils';
import { TrackedArray } from 'tracked-built-ins';

/*
attrs
  - filters
  - filterSettings = [{
    prop:  '',
    label: '',
    type:  string|number|boolean|select,
    options: [{ label: '', val: ''}]
      - only applies when type is 'select'
    mapValFn: function that maps the criteria val
      - optional
  }]

  - applyFilter(filters)
    - fired when filters should be applied

*/

export default Component.extend({
  filters: [[]],
  filterSettings: null,

  filtersChangesets: null,

  expanded: false,

  filterChangesetsAreDirty: true,

  individualFilters: computed('filtersChangesets.@each.length', function () {
    let filters = [];
    this.filtersChangesets.forEach((andFilters) => {
      andFilters.forEach((filter) => {
        filters.push(filter);
      });
    });
    return filters;
  }),
  noFilters: empty('individualFilters'),

  filterMessage: '',

  setFilterMessage() {
    let messages = [];
    let andFiltersLength = get(this, 'filters.firstObject.length');
    if (andFiltersLength == null || andFiltersLength === 0) {
      messages.push('All');
    } else {
      let filterSettings = this.filterSettings;
      let andFilters = this.filters[0];
      andFilters.forEach((filter) => {
        let filterSetting = filterSettings.find((x) => {
          return x.prop === filter.prop;
        });
        let val = filter.val;
        if (filterSetting.type === 'select') {
          val = filterSetting.options.find((x) => {
            return x.val === filter.val;
          }).label;
        }
        messages.push(
          `${filterSetting.label} ${filterUtils.operationLabels[filter.op]} '${val}'`,
        );
      });
    }
    set(this, 'filterMessage', messages.join(' and '));
  },

  didReceiveAttrs() {
    set(
      this,
      'filtersChangesets',
      this.removeUnusedFilters(JSON.parse(JSON.stringify(this.filters))),
    );
    this.setFilterMessage();
  },

  removeUnusedFilters(changesets) {
    changesets = changesets
      .map((andFilters) => {
        return andFilters.filter((x) => {
          return !isEmpty(get(x, 'val')) && !isEmpty(get(x, 'op'));
        });
      })
      .filter((andFilters) => {
        return andFilters.length > 0;
      })
      .map((andFilters) => {
        return new TrackedArray(andFilters);
      });

    if (changesets.length === 0) {
      changesets = [new TrackedArray([{}])];
    }

    return changesets;
  },

  handleApplyFilter: action(function () {
    set(
      this,
      'filtersChangesets',
      this.removeUnusedFilters(this.filtersChangesets),
    );

    let applyFilter = this.applyFilter;
    if (applyFilter) {
      let filters = [];
      this.filtersChangesets.forEach((andFilters) => {
        filters.push(
          andFilters.filter((x) => {
            return !isEmpty(get(x, 'val')) && !isEmpty(get(x, 'op'));
          }),
        );
      });
      applyFilter(filters);
    }
  }),

  addAndFilter: action(function () {
    this.filtersChangesets[0].push({});
  }),

  handleRemoveFilter: action(function (groupFilterIndex, item) {
    const changeset = this.filtersChangesets[groupFilterIndex];
    const index = changeset.indexOf(item);

    if (index !== -1) {
      changeset.splice(index, 1);
    }
  }),

  toggleExpanded: action(function () {
    this.toggleProperty('expanded');
    if (this.expanded && this.filtersChangesets[0].length === 0) {
      this.filtersChangesets[0] = new TrackedArray([{}]);
    }
  }),
});
